// extracted by mini-css-extract-plugin
export var quillEditor = "_jh-1";
export var variable = "_jh-0";